import { render, staticRenderFns } from "./zoomMinusButton.vue?vue&type=template&id=05f5c703&"
import script from "./zoomMinusButton.vue?vue&type=script&lang=ts&"
export * from "./zoomMinusButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports